module.exports = __webpack_public_path__ + "img/object-feature-object-before.b7ca2e2f.webp";